var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#08C108"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0562 7.95159C18.3856 8.24271 18.4164 8.74634 18.1253 9.07784L12.0159 15.9841C11.9454 16.0639 11.8595 16.1287 11.7635 16.1747C11.6675 16.2208 11.5632 16.2471 11.4568 16.2521C11.3504 16.2572 11.2441 16.2409 11.1441 16.2041C11.0442 16.1674 10.9526 16.111 10.8748 16.0383L6.89042 12.3195C6.73714 12.1751 6.64729 11.9758 6.64049 11.7653C6.6337 11.5548 6.71052 11.3502 6.85416 11.1961C6.99781 11.0421 7.19659 10.9512 7.40706 10.9433C7.61753 10.9354 7.82257 11.0111 7.97736 11.154L11.3667 14.3096L16.9342 8.01959C17.0036 7.94106 17.0879 7.877 17.1821 7.83107C17.2763 7.78515 17.3786 7.75825 17.4833 7.75194C17.5879 7.74562 17.6927 7.76 17.7918 7.79426C17.8908 7.82852 17.9821 7.88198 18.0605 7.95159H18.0562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdded);
export default __webpack_public_path__ + "static/media/added.e15410d924a46391a019719b96e1e475.svg";
export { ForwardRef as ReactComponent };